'use strict';

/*
    <div field-form class="row">

        <field-input title="'Name'" type="'date'" value="data.name" readonly="readonly" onchange="changed()">
        </field-input>

    </div>

*/

gs.component('fieldInput', {
    templateUrl: '/components/field/input/field.input.html',
    link: function(DI) {
        var $scope = DI.$scope;
        var prevValue;
        $scope.type = 'text';
        $scope.field = {
            value: null
        };

        DI.prop(['title', 'type', 'readonly']);
        var setter = DI.prop('value', function(value) {
            $scope.field.value = prevValue = value;
        }, {setter: true});

        $scope.changed = function() {
            var value = $scope.field.value;

            if(prevValue != value) {
                prevValue = value;
                setter(value);
                if(DI.$attrs.onchange) {
                    DI.$parse(DI.$attrs.onchange)(DI.$parentScope);
                }
            }
        };

    }
});
